// Externe Bibliotheken
import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router';

// Interne Module
import * as storage from '@/_helper//storage';

// Komponenten
import Button from '@/comp/button/button';

// Styles
import './consentBanner.scss';

export const ConsentBanner = () => {
    const COOKIE_NAME = window.$cookieName;
    const location = useLocation();
    const [gtmActive, setGtmActive] = useState(false);
    const [visible, setVisible] = useState(false);
    const event = new Event('cookieChange');

    useEffect(() => {
        const cookie = window.$gtmTracking.getCookie(COOKIE_NAME);
        if (!cookie) {
            if (location.pathname.includes('datenschutz')) {
                setVisible(false);
            } else {
                setVisible(true);
            }
        }

        if (window.$gtmTracking.isInit && document.cookie.includes(COOKIE_NAME) && gtmActive) {
            window.$gtmTracking.gtag('set', 'page_path', location.pathname + location.search + location.hash);
        }
    }, [COOKIE_NAME, gtmActive, location]);

    const init = () => {
        window.$gtmTracking.isInit = true;
        // if storage undefined or debug
        if (!storage.get(COOKIE_NAME)) {
            setGtmActive(false);
        }
        if (window.$gtmTracking.getCookie(COOKIE_NAME)) {
            const cookieData = window.$gtmTracking.getCookie(COOKIE_NAME);
            window.$gtmTracking.initializeGTM(location);
            setVisible(false);
            setGtmActive(cookieData.analytics_storage === 'granted');
        } else {
            setVisible(true);
            setGtmActive(true);
        }
    };
    if (!window.$gtmTracking.isInit) {
        init();
    }

    const showCookieLayer = () => {
        setVisible(true);
    };

    const hideCookieLayer = () => {
        setVisible(false);
    };

    if (!window.showCookieLayer) {
        window.showCookieLayer = showCookieLayer;
    }

    if (!window.hideCookieLayer) {
        window.hideCookieLayer = hideCookieLayer;
    }

    const acceptAll = () => {
        const consentMode = {
            analytics_storage: true,
            ad_storage: true,
            ad_user_data: true,
            ad_personalization: true,
        };
        changeConsentMode(consentMode);
        setGtmActive(true);
    };

    const declineAll = () => {
        const consentMode = {
            analytics_storage: false,
            ad_storage: false,
            ad_user_data: false,
            ad_personalization: false,
        };
        changeConsentMode(consentMode);
    };

    const changeConsentMode = (mode) => {
        window.$gtmTracking.setCookie(mode, location);
        setVisible(false);
        window.dispatchEvent(event);
    };

    const consentLayer = () => {
        return (
            <div className="clearance-control">
                <div className="clearance-container">
                    <div className="content">
                        <div className="text">
                            <h1 className="">Cookies erlauben?</h1>
                            <div className="clearance-link-container">
                                <NavLink to="/datenschutz" target="_blank">
                                    Datenschutz
                                </NavLink>
                                <a
                                    href={`${window.$website}/unternehmen/impressum`}
                                    target="_blank"
                                    rel="noopener noreferrer">
                                    Impressum
                                </a>
                            </div>
                            <p>
                                Cookies sind kleine Textdateien, die von Webseiten verwendet werden, um die
                                Benutzererfahrung effizienter zu gestalten. Wir verwenden Cookies, um das
                                Nutzungserlebnis für alle User kontinuierlich zu verbessern und Ihnen personalisierte
                                Empfehlungen ausspielen zu können. Durch den Klick auf "Alle Cookies zulassen", erteilen
                                Sie Ihre ausdrückliche Einwilligung. Diese Einstellung können Sie jederzeit über
                                "Konfigurieren" im Bereich Datenschutz anpassen. Die zugehörige Datenschutzerklärung
                                sowie weitere Informationen zu Cookies finden Sie{' '}
                                <NavLink to="/datenschutz" target="_blank">
                                    hier
                                </NavLink>
                                .
                            </p>
                        </div>
                        <div className="button-container">
                            <Button
                                handleClick={() => {
                                    acceptAll();
                                }}
                                label="Alle Cookies zulassen"
                            />
                            <Button
                                handleClick={() => {
                                    declineAll();
                                }}
                                classList="button-white"
                                label="Notwendige Cookies erlauben"
                            />
                            {!location.pathname.includes('datenschutz') && (
                                <NavLink className="button-element button-white" to="datenschutz">
                                    Anpassen
                                </NavLink>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return <>{visible && consentLayer()}</>;
};
export default ConsentBanner;
